import styled from '@emotion/styled';

export const LabelInformation = styled.label`
	color: ${({ theme }) => theme.colors.texts.primary};
`;
